export default __webpack_public_path__ + "static/media/room-view.a2ae89ca.jpg";